export const REDUCER_NAME = 'sentenceNotes';

export enum SENTENCE_NOTE_TYPE {
  ANNOTATIONS = 'annotation',
  OBLIGATIONS = 'obligation'
}
